import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import {
  CustomerForecastFilterItem,
  ExportCustomerForecastRateResponseAllOfResult,
} from '@/coreInfrastructureModule/axios/generated/customerForecastManage';

/**
 * 客先内示をエクスポートするUseCase
 */
export class ExportCustomerForecastUseCase {
  private repository: ICustomerForecastRepository;

  /**
   * コンストラクタ
   * @param repository - 内示リポジトリ
   */
  constructor(repository: ICustomerForecastRepository) {
    this.repository = repository;
  }

  /**
   * 客先内示をエクスポートする
   * @param startYear - 開始年
   * @param startMonth - 開始月
   * @param endYear - 終了年
   * @param endMonth - 終了月
   * @param receivedYear - 受領年
   * @param receivedMonth - 受領月
   * @param language - 出力言語（ja: 日本語、en: 英語）
   * @param filterItem - フィルター項目
   */
  public Execute = async (
    startYear: number,
    startMonth: number,
    endYear: number,
    endMonth: number,
    receivedYear: number,
    receivedMonth: number,
    language: string,
    filterItem?: CustomerForecastFilterItem
  ): Promise<INetworkResult<ExportCustomerForecastRateResponseAllOfResult, Error>> => {
    try {
      const result = await this.repository.exportCustomerForecast(
        startYear,
        startMonth,
        endYear,
        endMonth,
        receivedYear,
        receivedMonth,
        language,
        filterItem
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('客先内示のエクスポートに失敗しました'),
        },
      };
    }
  };
}
